<template>
  <div>
    <el-button
      style="margin-bottom: 20px"
      type="primary"
      @click="add(null)"
      v-if="hasAuth('sys:swp:add')"
      >添加
    </el-button>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column
        align="center"
        label="名称"
        prop="name"
      ></el-table-column>
      <el-table-column align="center" label="类型描述">
        <template slot-scope="scope">
          <div v-if="scope.row.type == 0" class="">商品详情</div>
          <div v-if="scope.row.type == 1" class="">商品分类</div>
          <div v-if="scope.row.type == 2" class="">直播</div>
          <div v-if="scope.row.type == 3" class="">公众号</div>
          <div v-if="scope.row.type == 4" class="">视频号</div>
          <div v-if="scope.row.type == 5" class="">隐私政策</div>
          <div v-if="scope.row.type == 6" class="">用户协议</div>
          <div v-if="scope.row.type == 7" class="">企业微信</div>
          <div v-if="scope.row.type == 8" class="">企业客服</div>
          <div v-if="scope.row.type == 9" class="">优惠券</div>
          <div v-if="scope.row.type == 10" class="">热销活动</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="图片">
        <template slot-scope="scope">
          <img :src="scope.row.imgUrl" alt="" height="50px" width="50px" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 1" type="success">已显示</el-tag>
          <el-tag v-if="scope.row.state == 0" type="danger">未显示</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="排序" prop="sort">
      </el-table-column>
      <el-table-column align="center" fixed="right" label="操作" prop="icon">
        <template slot-scope="scope">
          <el-button
            plain
            type="primary"
            @click="add(scope.row)"
            v-if="hasAuth('sys:swp:edit')"
            >编辑</el-button
          >
          <el-button
            plain
            type="danger"
            @click="delHandle(scope.row.id)"
            v-if="hasAuth('sys:swp:del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :before-close="handleClose"
      :title="editForm.id ? '编辑' : '新增'"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
    >
      <el-form
        ref="editForm"
        :model="editForm"
        :rules="rules"
        class="demo-editForm"
        label-width="140px"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="跳转类型" prop="type">
          <el-select
            v-model="editForm.type"
            clearable
            placeholder="选择跳转类型"
            style="width: 100%"
          >
            <el-option :value="0" label="商品详情"></el-option>
            <el-option :value="1" label="商品分类"></el-option>
            <el-option :value="2" label="直播"></el-option>
            <el-option :value="3" label="公众号"></el-option>
            <el-option :value="4" label="视频号"></el-option>
            <el-option :value="5" label="隐私政策"></el-option>
            <el-option :value="6" label="用户协议"></el-option>
            <el-option :value="7" label="企业微信"></el-option>
            <el-option :value="8" label="企业客服"></el-option>
            <el-option :value="9" label="优惠券"></el-option>
            <el-option :value="10" label="热销活动"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否显示" prop="state">
          <el-radio-group v-model="editForm.state">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="0">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="editForm.sort"></el-input>
        </el-form-item>
        <el-form-item
          v-if="editForm.type == 2"
          label="直播Id"
          label-width="100px"
          prop="liveId"
        >
          <el-input v-model="editForm.liveId"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.type == 3" label="公众号地址">
          <el-input v-model="editForm.officialAccountsId"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.type == 4" label="视频号Id" prop="videoId">
          <el-input
            v-model="editForm.videoId"
            placeholder="跳转视频号主页填写（‘sphzy’+视频号原始ID），跳转具体视频号视频填写具体视频ID"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item v-if="editForm.type == 7" label="地址">
          <el-input v-model="editForm.officialAccountsId"></el-input>
        </el-form-item>
        <el-form-item v-if="editForm.type == 0" label="跳转商品">
          <el-row>
            <el-col :span="18">
              <el-input v-model="editForm.tcommodityName" disabled></el-input>
            </el-col>
            <el-col :span="4">
              <el-button
                icon="el-icon-search"
                style="height: 40px; width: 100%"
                type="primary"
                @click="SelectGoods()"
                >选择商品
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item v-if="editForm.type == 1" label="跳转商品">
          <el-cascader
            ref="cateData"
            v-model="editForm.classify"
            :options="classifyList"
            :props="{ value: 'id', label: 'name', children: 'children' }"
            clearable
            filterable
            placeholder="选择分类"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="图片" prop="imgUrl">
          <VploadImg
            :limit="1"
            :type="1"
            v-bind:file-list="editForm.imgUrl"
            @submitImg="getImg"
          ></VploadImg>
        </el-form-item>
        <el-form-item style="margin-top: 80px">
          <el-button type="primary" @click="submitForm('editForm')"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :before-close="handlecrile"
      :visible.sync="goodsVisible"
      append-to-body
      title="选择商品"
      width="80%"
    >
      <div style="padding-bottom: 40px">
        <el-form :inline="true">
          <el-form-item label="商品名" label-width="80px">
            <el-input v-model="searchForm.name" clearable placeholder="商品名">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="serach()">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table
          ref="multipleTable"
          :data="goodsList"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column
            align="center"
            label="商品封面"
            prop="storeGoodsCover"
          >
            <template slot-scope="scope">
              <el-image
                :src="scope.row.cover"
                fit="scale-down"
                style="width: 70px; height: 70px"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="商品名称"
            prop="name"
          ></el-table-column>
          <el-table-column
            align="center"
            label="商品类型"
            prop="firstClassifyName"
          >
            <template slot-scope="scope">
              {{ scope.row.firstClassifyName }}-{{ scope.row.classifyName }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            prop="icon"
            width="120"
          >
            <template slot-scope="scope">
              <el-button
                v-if="editForm.commodityId != scope.row.id"
                plain
                type="primary"
                @click="clickgoods(scope.row)"
              >
                选择
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="searchForm.pageNo"
          :page-size="searchForm.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="searchForm.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="SizeChange"
          @current-change="CurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VploadImg from "../inc/VploadImgThree";

export default {
  name: "inswper",
  components: {
    VploadImg,
  },
  data() {
    return {
      editForm: {
        classify: [],
        classifyId: null,
        tcommodityId: null,
        tcommodityName: null,
        imgUrl: [],
        firstClassifyId: null,
        liveId: null,
        officialAccountsId: null,
        type: null,
        sort: 0,
        videoId: null,
      },
      tableData: [],
      dialogVisible: false,
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        videoId: [{ required: true, message: "请输入", trigger: "blur" }],
        liveId: [{ required: true, message: "请输入", trigger: "blur" }],
        officialAccountsId: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        classify: [{ required: true, message: "请选择", trigger: "blur" }],
        tcommodityName: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择", trigger: "blur" }],
        imgUrl: [{ required: true, message: "请上传", trigger: "blur" }],
      },
      classifyList: [],
      goodsVisible: false,
      searchForm: {
        name: "",
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      goodsList: [],
    };
  },
  created() {
    this.getHomePopList();
  },
  methods: {
    add(event) {
      if (event) {
        this.editForm = JSON.parse(JSON.stringify(event));
        this.editForm.imgUrl = [{ url: this.editForm.imgUrl }];
        this.editForm.classifyId = this.editForm.classifyId
          ? "a" + this.editForm.classifyId
          : null;
        this.editForm.classify = this.editForm.classifyId
          ? [this.editForm.firstClassifyId, this.editForm.classifyId]
          : [];
      }
      this.dialogVisible = true;
      this.getflList();
    },
    handleClose() {
      this.$refs["editForm"].resetFields();
      this.dialogVisible = false;
    },
    getHomePopList() {
      this.$axios
        .post("/admin/homeCarouse/getHomeCarouseList", {})
        .then((res) => {
          this.tableData = res.data;
        });
    },
    SelectGoods() {
      this.goodsVisible = true;
      this.searchForm.pageNo = 1;
      this.serach();
    },
    handlecrile() {
      this.goodsVisible = false;
      this.serach();
    },
    SizeChange(val) {
      this.searchForm.pageSize = val;
      this.serach();
    },
    CurrentChange(val) {
      this.searchForm.pageNo = val;
      this.serach();
    },
    clickgoods(row) {
      this.editForm.tcommodityId = row.id;
      this.editForm.tcommodityName = row.name;
      this.goodsVisible = false;
    },
    serach() {
      var obj = JSON.parse(JSON.stringify(this.searchForm));
      delete obj.total;
      this.$axios
        .post("/admin/commodity/getUpperCommodityList", this.searchForm)
        .then((res) => {
          this.goodsList = res.data.records;
          this.searchForm.total = res.data.total;
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = {
            classifyId:
              this.editForm.classify.length > 0
                ? this.editForm.classify[1].substring(1)
                : null,
            firstClassifyId:
              this.editForm.classify.length > 0
                ? this.editForm.classify[0]
                : "",
            imgUrl:
              this.editForm.imgUrl.length > 0
                ? this.editForm.imgUrl[0].url
                : "",
            liveId: this.editForm.liveId,
            name: this.editForm.name,
            officialAccountsId: this.editForm.officialAccountsId,
            sort: this.editForm.sort,
            state: this.editForm.state,
            tcommodityId: this.editForm.tcommodityId,
            type: this.editForm.type,
            videoId: this.editForm.videoId,
          };
          if (this.editForm.id) {
            obj.id = this.editForm.id;
            this.$axios
              .post("/admin/homeCarouse/updateHomeCarouse", obj)
              .then((res) => {
                this.handleClose();
                this.getHomePopList();
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          } else {
            this.$axios
              .post("/admin/homeCarouse/addHomeCarouse", obj)
              .then((res) => {
                this.handleClose();
                this.getHomePopList();
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success",
                });
              });
          }
        } else {
          return false;
        }
      });
    },
    getImg(img, add) {
      this.editForm.imgUrl = add == 0 ? [] : [{ url: img }];
    },
    getflList() {
      this.$axios
        .get("/admin/commodityClassify/getAllLevelList")
        .then((res) => {
          this.classifyList = res.data;
        });
    },
    delHandle(event) {
      var _this = this;
      this.$confirm("此操作将永久删除该轮播图, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post("/admin/homeCarouse/deleteHomeCarouse", {
              id: event,
            })
            .then((res) => {
              _this.getHomePopList();
              _this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.el-button {
  padding: 0 10px;
  height: 35px;
  line-height: 35px;
  font-size: 15px;
  margin-right: 10px;
}
</style>
